import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { RegisterAccountTypeComponent } from "./pages/account-type/account-type.component";
import { AuthGuardGuard } from "src/app/core/guards/auth-guard.guard";
import { InvitationRegistrationComponent } from "./components/invitation-registration/invitation-registration.component";
import { DeeplinkComponent } from "./components/deeplink/deeplink.component";

const routes: Routes = [
  { path: "selectaccounttype", component: RegisterAccountTypeComponent },
  {
    path: "invitation-registration/:inviteId",
    component: InvitationRegistrationComponent,
  },
  {
    path: "deeplink/:content",
    component: DeeplinkComponent,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [],
  declarations: [],
})
export class RegisterRoutingModule {}
